import Vue from 'vue';
import CategoryChip from './Category.vue';
import CategoriesChip from './Categories.vue';

Vue.component('category-chip', CategoryChip);
Vue.component('categories-chip', CategoriesChip);
